import angular from 'angular';

// Component
import component from './serverSideLoginScreen.component';

// Load all services
import '../../../lib/service';

import constantsModuleName from '../../../lib/constants';

// Dependencies
import translation from '../../../lib/translation';
import errorList from '../../../lib/components/errorList';

const moduleName = 'staff.serverSideLoginScreen';
let module = angular.module(moduleName, [
  errorList.name,
  'recaps.services',
  translation,
  constantsModuleName,
]);

module.component('serverSideLoginScreen', component);

export default module;
